<template>
    <div class="msg-subscr-msanage">
        <div class="hint block mb10">
            <div class="title">温馨提示</div>
            <p>逐条检查：一条一条的检查，因数据较多花费时间较长</p>
        </div>
        <div class="hint block mb10">
            <p>逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长</p>
        </div>
        <div class="hint block">
            <p>导入excel文件的单元格格式推荐使用常规或文本</p>
        </div>
        <div class="message-body mt10">
            <ul class="native-table">
                <li class="table-tr">
                    <div class="table-th" style="text-align: left">列名</div>
                    <div class="table-th" style="width: 120px">是否必填</div>
                    <div class="table-th" style="text-align: left">其他要求</div>
                    <!--<div class="table-th" style="text-align: left">正确示例</div>-->
                    <div class="table-th">不符合要求的结果</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">机构名称</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">地址信息</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">详细地址</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">联系人</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">联系电话</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">供应商</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">商品名称</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">分类</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">品牌</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>

                <li class="table-tr">
                    <div class="table-td" style="text-align: left">组装件</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">是否作为组装件</div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">含税价(元)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">税率(%)</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">未税价(元)</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">根据价格-税率计算，无需输入</div>
                    <div class="table-td">-</div>
                </li>

                <li class="table-tr">
                    <div class="table-td" style="text-align: left">配货数量</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择以系统的为准，最小为0、正整数</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">单位</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">根据模板生成，不可以修改</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">说明</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择以系统的为准</div>
                    <!--<div class="table-td" style="text-align: left"></div>-->
                    <div class="table-td">-</div>
                </li>

            </ul>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-alloc-form-format-expl',
        desc: '配货导入文件格式说明',
        data: function () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/AllocFormFormatExpl.vue